import styled from "styled-components";
import { Paper as MuiPaperWithoutSpacing, Grid } from "@mui/material";

const NonShadowPaper = styled(MuiPaperWithoutSpacing)`
  border-radius: 10px;
  margin: 10px 0;
  padding: 15px;
`;

export default function Paper({
  gridSpacing,
  variant,
  noGrid,
  gridProps,
  children,
  ...props
}) {
  return (
    <NonShadowPaper variant={variant} {...props}>
      {noGrid ? (
        children
      ) : (
        <Grid
          container
          alignItems="flex-start"
          {...gridProps}
          spacing={gridSpacing ?? 4}
        >
          {children}
        </Grid>
      )}
    </NonShadowPaper>
  );
}
